{
  "myCases.detail.back": "Takaisin listaukseen",
  "myCases.detail.employer": "Työnantaja",
  "myCases.detail.heading": "Viestin tiedot",
  "myCases.detail.source": "Lähde",
  "myCases.detail.closedReplyNote": "Tämä keskustelu on suljettu, eikä siihen voi enää vastata. Jos tarvitset edelleen apua, voit ottaa yhteyttä uudella keskustelulla.",
  "myCases.detail.notFound": "Viestiä ei löytynyt.",
  "myCases.detail.unavailable": "Viestin tietoja ei juuri nyt saada haettua. Yritä myöhemmin uudelleen.",
  "myCases.detail.messagesHeading": "Viestit",
  "myCases.detail.noMessages": "Ei viestejä.",
  "myCases.detail.systemAuthor": "YTK Työelämä",
  "myCases.detail.selfAuthor": "Sinä",
  "myCases.detail.contactSummaryHeading": "Yhteydenottosi",
  "myCases.detail.attachmentsHeading": "Liitteet",
  "myCases.detail.download": "Lataa",
  "myCases.detail.attachmentBeingChecked": "Liitettä tarkistetaan tietoturvan vuoksi, eikä sitä voi juuri nyt ladata.",
  "myCases.detail.downloadFailed": "Lataus ei onnistunut. Yritä myöhemmin uudelleen.",
  "myCases.detail.replyLabel": "Vastaa",
  "myCases.detail.replyPlaceholder": "Kirjoita vastauksesi…",
  "myCases.detail.removeAttachment": "Poista liite",
  "myCases.detail.uploadTooMany": "Liitteitä on liikaa. Poista jokin ennen lähettämistä.",
  "myCases.detail.replySend": "Lähetä vastaus",
  "myCases.detail.replySending": "Lähetetään…",
  "myCases.detail.replySent": "Vastaus lähetetty.",
  "myCases.detail.replyFailed": "Vastausta ei juuri nyt saatu lähetettyä. Yritä uudelleen.",
  "myCases.detail.replyEmpty": "Kirjoita viesti tai lisää liite ennen lähettämistä.",
  "myCases.detail.replyTooLong": "Vastaus on liian pitkä (enintään 4 000 merkkiä). Lyhennä sitä.",
  "myCases.detail.uploadLabel": "Lisää liite (PDF, PNG, JPEG, DOCX tai XLSX, enintään 25 Mt)",
  "myCases.detail.chooseFile": "Valitse tiedosto",
  "myCases.detail.attachmentCountHint": "Enintään {max} liitettä ({count} valittu)",
  "myCases.detail.charCountUnit": "merkkiä",
  "myCases.detail.uploadBeingChecked": "Liite lähetetty. Sitä tarkistetaan tietoturvan vuoksi, eikä sitä voi vielä ladata.",
  "myCases.detail.uploadTooLarge": "Tiedosto on liian suuri. Kokeile pienempää tiedostoa.",
  "myCases.detail.uploadUnsupported": "Tiedostotyyppiä ei tueta. Sallitut tyypit: PDF, PNG, JPEG, DOCX ja XLSX.",
  "myCases.detail.uploadFailed": "Liitteen lähetys ei juuri nyt onnistunut. Yritä uudelleen.",
  "myCases.empty": "Sinulla ei ole vielä viestejä.",
  "myCases.heading": "Omat viestit",
  "myCases.source.ai_originated": "Lakikaveri-keskustelusta",
  "myCases.source.standalone_contact": "Ota yhteyttä -lomake",
  "myCases.status.acknowledged": "Vastaanotettu",
  "myCases.status.closed": "Suljettu",
  "myCases.status.created": "Luotu",
  "myCases.status.failed": "Epäonnistunut",
  "myCases.status.routed": "Ohjattu käsiteltäväksi",
  "myCases.loading": "Ladataan…",
  "myCases.unavailable": "Viestien haku ei juuri nyt onnistu. Yritä myöhemmin uudelleen.",
  "myCases.untitled": "Nimetön viesti",
  "myCases.unread": "Lukematon",
  "myCases.statusPrefix": "Tila:",
  "myCases.loadMore": "Lataa lisää viestejä",
  "myCases.loadingMore": "Ladataan lisää viestejä…",
  "myCases.moreLoaded": "Lisää viestejä ladattu. Näkyvissä nyt {count} viestiä.",
  "myCases.allShown": "Kaikki viestit näkyvissä.",
  "myCases.loadMoreFailed": "Lisää viestejä ei juuri nyt saatu ladattua. Yritä uudelleen."
}
